import React, { Component } from 'react';
import { ColorUtils } from '../../../../../../utils/helpers';
import TextFieldColorPicker from '../../../../../generic/TextFieldColorPicker';
import CssPaddingSelector from '../../../../../generic/CssPaddingSelector';
import { Checkbox, TextField } from '@cimpress/react-components';
import { XBlockPropertiesProps } from '../../../models/XBlockProps';
import { XBlockPropertiesState } from '../../../models/XBlockState';
import { DEBOUNCE_TIME_INTERVAL } from '../../../../../../constants';
import debounce from 'debounce';

class XTextProperties extends Component<XBlockPropertiesProps, XBlockPropertiesState> {
  updateProperties:Function;

  constructor(props) {
    super(props);
    this.state = {
      updates: props.properties
    };
    this.updateProperties = debounce(this.confirm, DEBOUNCE_TIME_INTERVAL);
  }

  componentDidUpdate(prevProps,prevState){
    if (JSON.stringify(prevProps.properties) !== JSON.stringify(this.props.properties)) {
      this.setState({
        updates: this.props.properties
      });
    }
    if (JSON.stringify(prevState.updates) !== JSON.stringify(this.state.updates) && prevProps.id === this.props.id){
      this.updateProperties();
    }
    if (prevProps.id !== this.props.id){
      this.props.onUpdateItem({ id: prevProps.id }, this.state.updates);
    }
  }

  confirm() {
    this.props.onUpdateItem({ id: this.props.id }, this.state.updates);
  }

  render() {
    const { t } = this.props;
    const props = this.state.updates || this.props.properties || {};
    
    return <React.Fragment>
      <TextFieldColorPicker
        name='backgroundColor'
        label={t('blocks.background_color')}
        helpText={t('blocks.background_color_help_text')}
        color={ColorUtils.rgb2hex(props.backgroundColor)}
        onTextChange={(e) => {
          this.setState({ updates: Object.assign({}, this.state.updates, { backgroundColor: e.target.value }) });
        }}
        onColorChange={(hexColor) => {
          this.setState({ updates: Object.assign({}, this.state.updates, { backgroundColor: hexColor }) });
        }} />

      <CssPaddingSelector
        t={t}
        label={t('blocks.padding')}
        helpText={t('blocks.padding_help_text')}
        padding={props.padding}
        onChange={(value) => this.setState({ updates: Object.assign({}, this.state.updates, { padding: value }) })}
      />

      <TextField
        name='class'
        label={t('blocks.class')}
        helpText={t('blocks.class_help_text')}
        value={props.class}
        onChange={(e) => {
          this.setState({ updates: Object.assign({}, this.state.updates, { class: e.target.value }) });
        }} />

      <Checkbox
        label={t('blocks.paragraphs_as_divs')}
        checked={!!props.treatParagraphsAsDiv}
        onChange={(_e) => this.setState({ updates: Object.assign({}, this.state.updates, { treatParagraphsAsDiv: !props.treatParagraphsAsDiv }) })}
      />
    </React.Fragment>;
  }
}

export default XTextProperties;
